import React from 'react';
import { get, upperFirst, size, first, last } from 'global/lib/lodash';
import useStyles from './styles';
import { Loading } from 'global/styles';
import moment from 'moment';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { getRealmIcon } from 'global/components/droprealms';
import { useDispatch } from 'react-redux';
import { clearNewAlert } from 'redux/actions/view';
import { getRealmName } from 'global/utils';

export default (props) => {
  const { item, index, showLocation } = props;
  const showbg = index % 2;

  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles({ showbg, showLocation });

  const getType = () => {
    let type = get(item, 'logName', '');
    const split = type.split('_');

    if (size(split) < 2) {
      return type;
    } else {
      const firstText = (() => {
        const t = last(split);
        return upperFirst(t === 'activity' ? 'new' : t);
      })();
      const secondText = (() => {
        const t = first(split);
        return upperFirst(t === 'assessment' ? 'report' : t);
      })();
      return `${firstText} ${secondText}`;
    }
  };

  const getDescription = () => {
    return get(item, 'description', 'None');
  };

  const getLocation = () => {
    const realm = get(item, 'realms.0');
    if (realm) {
      const icon = getRealmIcon(realm);
      return (
        <div className={classes.flexRow}>
          {icon}
          <span style={{ marginLeft: 5 }}>{getRealmName({ realm })}</span>
        </div>
      );
    }

    return <div className={classes.flexRow} />;
  };

  const onClick = () => {
    const type = get(item, 'subjectType');
    const metaType = get(item, 'meta.activityType');
    const subject = get(item, 'subject');
    const id = get(subject, 'id');
    const commentableType = get(subject, 'commentableType');
    const commentableId = get(subject, 'commentableId');

    if (type === 'assessment') {
      const metaId = get(item, 'meta.courseAssignmentId');
      if (metaType === 'course_assignment_assessment' && metaId) {
        history.push(`/courses/${metaId}`);
      } else {
        //reports/assessment/735
        history.push(`/reports/assessment/${id}`);
      }
    } else if (type === 'task' || commentableType === 'task') {
      //tasks/detail/8525
      if (commentableType === 'task') {
        history.push(`/tasks/detail/${commentableId}`);
      } else {
        history.push(`/tasks/detail/${id}`);
      }
    } else {
      alert('Row does not fit the expected schema.');
      console.log('TODO');
    }

    dispatch(clearNewAlert(item));

    props.onClick && props.onClick(item);
  };

  const content = {
    ...item,
    type: getType(),
    description: getDescription(),
    time: get(item, 'createdAt') ? moment(get(item, 'createdAt')).fromNow() : Loading,
    isNew: get(item, 'new'),
    location: getLocation(),
  };

  return (
    <div onClick={onClick} className={clsx(classes.row, showbg && classes.rowBg, content.isNew && classes.newRow)}>
      <div className={classes.info}>
        <div className={classes.type}>{content.type}</div>
        {showLocation && <div className={classes.location}>{content.location}</div>}
        <div className={classes.description}>{content.description}</div>
      </div>
      <div className={classes.time}>{content.time}</div>
    </div>
  );
};
